import { useContext } from "react";
import { usePathname } from "next/navigation";
import { useGetComments, useGetDetail, useGetLocation } from "@/api/traveler";
import FirebaseContext from "@/context/firebaseContext/firebaseContext";
import { ActivityDetailGeoSearch } from "@/model";
import { FirebaseContextType, StaticInfoType } from "@/types/components";

export const useActivity = (
  id: string,
  detail_info: ActivityDetailGeoSearch | undefined,
) => {
  const { data: location } = useGetLocation(parseInt(id), {
    query: { refetchOnWindowFocus: false, staleTime: Infinity },
  });

  const { data: more_info } = useGetDetail(parseInt(id), {
    query: {
      refetchOnWindowFocus: false,
      staleTime: Infinity,
    },
  });

  const { logAnalyticsEvent } = useContext(
    FirebaseContext,
  ) as FirebaseContextType;

  const staticInfo = {
    language: "",
    duration: "",
    accessibility: "",
    public: [],
    pet_friendly: false,
    description: "",
  } as StaticInfoType;

  const pathname = usePathname();

  if (detail_info) {
    if (detail_info.language) {
      staticInfo.language = detail_info.language.name ?? "";
    }
    if (detail_info.description) {
      // const staticInfoToArray = detail_info.description.split(" ");
      // for (let i = 0; i < staticInfoToArray.length - 1; i++) {
      //   if (
      //     (staticInfoToArray[i].includes(".") ||
      //       staticInfoToArray[i].includes("...")) &&
      //     staticInfoToArray[i + 1].match(/[^a-zA-Z0-9]/)
      //   ) {
      //     staticInfoToArray[i] = staticInfoToArray[i] + "\n";
      //   }
      // }
      // staticInfo.description = staticInfoToArray.join(" ");
      staticInfo.description = detail_info.description;
    }
    if (detail_info.manualDuration) {
      staticInfo.duration = detail_info.manualDuration;
    }
    if (more_info) {
      more_info.tags?.map((tag: any) => {
        if (tag === "Pet friendly" || tag?.name === "Pet friendly") {
          staticInfo.pet_friendly = true;
        }
        if (
          tag === "Para grupos" ||
          tag === "Solo adultos" ||
          tag == "Para niños" ||
          tag == "Para todo el público" ||
          tag == "Apto para todo público"
        ) {
          staticInfo.public.push(tag);
        } else if (
          tag?.name === "Para grupos" ||
          tag?.name === "Solo adultos" ||
          tag?.name == "Para niños" ||
          tag?.name == "Para todo el público" ||
          tag?.name == "Apto para todo público"
        ) {
          staticInfo.public.push(tag.name);
        }
        if (
          tag === "Personas con movilidad reducida" ||
          tag?.name === "Personas con movilidad reducida"
        ) {
          staticInfo.accessibility = "Personas con movilidad reducida";
        }
      });
    }
    logAnalyticsEvent("view_item", {
      value: detail_info.price, // Precio del ítem (cambia dinámicamente)
      items: [
        {
          id: detail_info.id, // ID de la actividad (cambia dinámicamente)
          item_title: detail_info.name, // Título de la actividad (cambia dinámicamente)
          item_description: detail_info.description,
          final_url: pathname, // URL de la actividad (cambia dinámicamente)
          image_url: detail_info.images ? detail_info.images[0].link : "", // URL de la imagen (cambia dinámicamente)
          price: detail_info.price, // Precio original (cambia dinámicamente)
          item_category: detail_info.category.name,
          item_subcategory: detail_info.subcategory?.name,
          item_location: detail_info.city,
        },
      ],
    });
  }

  const { data: activity_comments } = useGetComments(
    parseInt(id),
    {},
    {
      query: { refetchOnWindowFocus: false, staleTime: Infinity },
    },
  );

  return {
    location,
    staticInfo,
    activity_comments,
    more_info,
  };
};
